import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 72,
      height: 122,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(1, 0.25),
      borderRadius: theme.shape.borderRadius,
      border: '1px solid',
      borderColor: COLORS.primary.light,

      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
      '&:focus': {
        backgroundColor: COLORS.primary.silver,
      },
    },

    skeleton: {
      borderRadius: 6,
      fontSize: theme.typography.pxToRem(11),
      background: COLORS.primary.silver,

      '&:after': {
        background: 'linear-gradient(90deg, transparent, white, transparent)',
      },
    },

    circular: {
      borderRadius: '50%',
    },

    topTextWrapper: {
      marginTop: theme.spacing(0.75),
    },

    topText: {
      width: '100%',
      paddingRight: theme.spacing(1.5),
      paddingLeft: theme.spacing(1.5),
    },

    bottomText: {
      width: '100%',
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
    },
  }),
  { name: 'PersonaButtonSkeleton' }
);
